export default __webpack_public_path__ + "static/media/instagram-logo.a21c478f.png";